import { IsBoolean, IsNotEmpty, IsOptional, IsString, MaxLength } from "class-validator";

export class ScoreConflictDto {
  @IsNotEmpty()
  @IsBoolean()
  conflict: boolean;

  /** Optional note captured when a competitor flags a conflict on mobile. */
  @IsOptional()
  @IsString()
  @MaxLength(200)
  conflict_note?: string;
}
